import { useEffect, useRef } from "react";

export const useEffectOnce = (callback: () => void | (() => void)) => {
  const callbackRef = useRef(callback);

  useEffect(() => {
    return callbackRef.current();
  }, [callbackRef]);
};
